import { absolutePath } from "@/react/helpers/urlHelpers/internalApi/absolutePath";

export const mediaChapterGenerations = {
  show: ({ id }: { id: number }) =>
    absolutePath(`media_chapter_generations/${id}`),
  create: () => absolutePath("media_chapter_generations"),
  destroy: ({ id }: { id: number }) =>
    absolutePath(`media_chapter_generations/${id}`),
};
